export default {
  order: 5,
  icon: 'mdi-cash-register',
  sections: [
    {
      id: 'open-shift',
      label: 'Otvaranje smjene',
      getContent: getOpenShiftContent
    },
    {
      id: 'issue-receipt',
      label: 'Izdavanje računa',
      getContent: getIssueReceiptContent
    },
    {
      id: 'tables',
      label: 'Rad sa stolovima',
      getContent: getTablesContent
    },
    {
      id: 'close-balance',
      label: 'Zatvaranje smjene',
      getContent: getCloseBalanceContent
    }
  ]
}

function getOpenShiftContent () {
  return `
    <h2 id="what-is">Što je otvaranje smjene?</h2>
    <p>
      Otvaranje smjene je proces kojim korisnik započinje rad na blagajni.
      Svaka smjena ima početno stanje gotovine i završava zatvaranjem smjene
      sa pregledom ukupne prodaje.
    </p>

    <h2 id="when-to-use" class="mt-6">Kada otvoriti smjenu?</h2>
    <ul>
      <li>Na početku radnog dana</li>
      <li>Prilikom preuzimanja smjene od drugog korisnika</li>
      <li>Nakon zatvaranja prethodne smjene</li>
    </ul>

    <h2 id="prerequisites" class="mt-6">Preduvjeti</h2>
    <ul>
      <li>Korisnik mora imati privilegije za rad na blagajni</li>
      <li>Blagajna mora biti u statusu "OK" (slobodna)</li>
      <li>Prethodna smjena mora biti zatvorena</li>
    </ul>

    <h2 id="step-by-step" class="mt-6">Korak po korak</h2>

    <h3 class="mt-4">1. Pristup blagajni</h3>
    <ol>
      <li>Idite na "Prodajna mjesta" → "Blagajne"</li>
      <li>Pronađite blagajnu sa statusom <span class="status-chip success">OK</span></li>
      <li>Kliknite na blagajnu</li>
    </ol>

    <h3 class="mt-4">2. Prijava na blagajnu</h3>
    <p>Ovisno o tipu prijave blagajne:</p>
    <ul>
      <li><strong>DEFAULT:</strong> Automatska prijava - nije potrebna dodatna akcija</li>
      <li><strong>SELECT_USER:</strong> Odaberite korisnika iz liste</li>
      <li><strong>PINCODE:</strong> Unesite svoj PIN kod</li>
    </ul>

    <h3 class="mt-4">3. Unos početnog stanja</h3>
    <p>Nakon prijave, sustav će tražiti početno stanje gotovine:</p>
    <ol>
      <li>Prebrojite gotovinu u blagajni</li>
      <li>Unesite iznos u polje "Početno stanje"</li>
      <li>Kliknite "Potvrdi"</li>
    </ol>

    <div class="info-box mt-4">
      <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
      <strong>Napomena:</strong> Početno stanje je važno za ispravno zatvaranje smjene.
      Uvijek točno prebrojite gotovinu prije unosa!
    </div>

    <h2 id="fields" class="mt-6">Polja i opcije</h2>
    <table class="info-table">
      <thead>
        <tr>
          <th>Polje</th>
          <th>Opis</th>
          <th>Obavezno</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>Korisnik</strong></td>
          <td>Korisnik koji otvara smjenu (automatski ili odabir)</td>
          <td>Da</td>
        </tr>
        <tr>
          <td><strong>Početno stanje</strong></td>
          <td>Iznos gotovine u blagajni na početku smjene</td>
          <td>Da</td>
        </tr>
        <tr>
          <td><strong>Napomena</strong></td>
          <td>Dodatna napomena za smjenu (opcionalno)</td>
          <td>Ne</td>
        </tr>
      </tbody>
    </table>

    <h2 id="tips" class="mt-6">Savjeti i trikovi</h2>
    <div class="success-box">
      <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
      <strong>Savjet:</strong> Vodite evidenciju početnih stanja u papirnatom ili digitalnom dnevniku
      za lakše praćenje i kontrolu.
    </div>

    <h2 id="troubleshooting" class="mt-6">Što ako...?</h2>
    <details>
      <summary>Blagajna je rezervirana (RESERVED)?</summary>
      <p>
        To znači da drugi korisnik trenutno koristi blagajnu. Pričekajte da završi
        rad ili kontaktirajte administratora ako je blagajna blokirana.
      </p>
    </details>

    <details>
      <summary>Zaboravio sam unijeti početno stanje?</summary>
      <p>
        Morate zatvoriti smjenu i otvoriti novu sa ispravnim početnim stanjem.
        Kontaktirajte administratora za korekciju.
      </p>
    </details>
  `
}

function getIssueReceiptContent () {
  return `
    <h2 id="what-is">Što je izdavanje računa?</h2>
    <p>
      Izdavanje računa je osnovni proces prodaje na blagajni. Uključuje odabir artikala,
      unos količine, primjenu popusta, odabir načina plaćanja i automatsku fiskalizaciju.
    </p>

    <h2 id="when-to-use" class="mt-6">Kada izdati račun?</h2>
    <ul>
      <li>Prilikom prodaje artikala kupcu</li>
      <li>Za gotovinska plaćanja</li>
      <li>Za plaćanja karticom</li>
      <li>Za online narudžbe (delivery)</li>
    </ul>

    <h2 id="prerequisites" class="mt-6">Preduvjeti</h2>
    <ul>
      <li>Smjena mora biti otvorena</li>
      <li>Artikli moraju biti na cjeniku</li>
      <li>FINA certifikat mora biti važeći (za fiskalizaciju)</li>
    </ul>

    <h2 id="step-by-step" class="mt-6">Korak po korak</h2>

    <h3 class="mt-4">1. Odabir artikala</h3>
    <p>Postoji više načina dodavanja artikala na račun:</p>
    <ul>
      <li><strong>Klik na artikal:</strong> Kliknite na artikal iz kategorija</li>
      <li><strong>Pretraga:</strong> Koristite search polje za brzo pronalaženje</li>
      <li><strong>Barcode:</strong> Skenirajte barcode artikla</li>
      <li><strong>Kategorije:</strong> Navigirajte kroz kategorije artikala</li>
    </ul>

    <h3 class="mt-4">2. Unos količine</h3>
    <p>Nakon dodavanja artikla:</p>
    <ol>
      <li>Artikal se pojavljuje na računu sa količinom 1</li>
      <li>Kliknite na količinu za promjenu</li>
      <li>Unesite željenu količinu</li>
      <li>Pritisnite Enter ili kliknite "Potvrdi"</li>
    </ol>

    <div class="info-box mt-4">
      <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
      <strong>Napomena:</strong> Za artikle sa težinskom jedinicom (kg), unesite težinu u decimalnom formatu (npr. 0.5 za 500g).
    </div>

    <h3 class="mt-4">3. Primjena popusta (opcionalno)</h3>
    <p>Ako želite dodati popust:</p>
    <ol>
      <li>Kliknite na artikal</li>
      <li>Odaberite "Dodaj popust"</li>
      <li>Unesite postotak ili fiksni iznos</li>
      <li>Kliknite "Primijeni"</li>
    </ol>

    <h3 class="mt-4">4. Odabir načina plaćanja</h3>
    <p>Kada ste završili sa dodavanjem artikala:</p>
    <ol>
      <li>Kliknite gumb "Naplati" ili pritisnite F12</li>
      <li>Odaberite način plaćanja:
        <ul>
          <li><strong>Gotovina:</strong> Unesite primljeni iznos</li>
          <li><strong>Kartica:</strong> Odaberite tip kartice</li>
          <li><strong>POS uređaj:</strong> Terminal za plaćanje karticom</li>
          <li><strong>Mješovito:</strong> Kombinacija više načina</li>
        </ul>
      </li>
      <li>Za gotovinu - sustav će prikazati povrat</li>
      <li>Kliknite "Završi"</li>
    </ol>

    <h3 class="mt-4">5. Fiskalizacija i ispis</h3>
    <p>Nakon završetka plaćanja:</p>
    <ol>
      <li>Sustav automatski šalje račun na fiskalizaciju (FINA)</li>
      <li>Račun dobiva JIR i ZKI kod</li>
      <li>Račun se automatski ispisuje na pisaču</li>
      <li>Stanje skladišta se ažurira (ako koristite skladište)</li>
    </ol>

    <h2 id="fields" class="mt-6">Načini plaćanja</h2>
    <table class="info-table">
      <thead>
        <tr>
          <th>Način plaćanja</th>
          <th>Opis</th>
          <th>Fiskalizacija</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>Gotovina (CASH)</strong></td>
          <td>Plaćanje gotovinom - potreban unos primljenog iznosa</td>
          <td>Odmah</td>
        </tr>
        <tr>
          <td><strong>Kartica (CARD)</strong></td>
          <td>Plaćanje platnom karticom (Visa, Mastercard, Maestro)</td>
          <td>Odmah</td>
        </tr>
        <tr>
          <td><strong>POS uređaj</strong></td>
          <td>Povezan POS terminal za plaćanje karticom</td>
          <td>Odmah</td>
        </tr>
        <tr>
          <td><strong>Transakcijski račun</strong></td>
          <td>Plaćanje preko bankovnog računa</td>
          <td>Odgođeno</td>
        </tr>
        <tr>
          <td><strong>Čekovi</strong></td>
          <td>Plaćanje čekom</td>
          <td>Odgođeno</td>
        </tr>
        <tr>
          <td><strong>Ostalo</strong></td>
          <td>Drugi načini plaćanja</td>
          <td>Odmah</td>
        </tr>
      </tbody>
    </table>

    <h2 id="keyboard-shortcuts" class="mt-6">Keyboard shortcuts</h2>
    <table class="info-table">
      <thead>
        <tr>
          <th>Tipka</th>
          <th>Akcija</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><code>F1</code></td>
          <td>Otvori pretragu artikala</td>
        </tr>
        <tr>
          <td><code>F2</code></td>
          <td>Dodaj popust na artikal</td>
        </tr>
        <tr>
          <td><code>F9</code></td>
          <td>Obriši stavku sa računa</td>
        </tr>
        <tr>
          <td><code>F12</code></td>
          <td>Završi račun / Naplati</td>
        </tr>
        <tr>
          <td><code>ESC</code></td>
          <td>Odustani / Zatvori dialog</td>
        </tr>
      </tbody>
    </table>

    <h2 id="tips" class="mt-6">Savjeti i trikovi</h2>
    <div class="success-box">
      <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
      <div>
        <strong>Brži rad:</strong>
        <ul>
          <li>Koristite barcode scanner za brže skeniranje</li>
          <li>Zapamtite keyboard shortcuts</li>
          <li>Organizirajte kategorije po učestalosti korištenja</li>
          <li>Za česte artikle - stavite ih na "favorites"</li>
        </ul>
      </div>
    </div>

    <div class="warning-box mt-4">
      <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
      <strong>Važno:</strong> Uvijek provjerite iznos prije fiskalizacije! Nakon fiskalizacije,
      račun se može samo stornirati, ne i ispraviti.
    </div>

    <h2 id="troubleshooting" class="mt-6">Što ako...?</h2>
    <details>
      <summary>Artikl nema cijenu?</summary>
      <p>
        Artikal mora biti dodan na cjenik prodajnog mjesta. Idite na "Cjenik" i
        dodajte artikal sa cijenom.
      </p>
    </details>

    <details>
      <summary>Fiskalizacija ne uspijeva?</summary>
      <p>
        Provjerite:
      </p>
      <ul>
        <li>Internetsku vezu</li>
        <li>Valjanost FINA certifikata</li>
        <li>Dostupnost FINA servera</li>
      </ul>
      <p>Račun ostaje u statusu FAILED i možete ga ponovno fiskalizirati iz pregleda računa.</p>
    </details>

    <details>
      <summary>Kako stornirati račun?</summary>
      <p>
        Storno se radi iz pregleda računa:
      </p>
      <ol>
        <li>Idite na "Računi"</li>
        <li>Pronađite račun</li>
        <li>Kliknite "Storno"</li>
        <li>Unesite razlog storna</li>
        <li>Potvrdi</li>
      </ol>
    </details>

    <details>
      <summary>Kako podijeliti račun (split)?</summary>
      <p>
        Za dijeljenje računa:
      </p>
      <ol>
        <li>Dodajte sve artikle na račun</li>
        <li>Kliknite "Podijeli račun"</li>
        <li>Odaberite artikle za prvi račun</li>
        <li>Preostali artikli idu na drugi račun</li>
        <li>Svaki račun se fiskalizira zasebno</li>
      </ol>
    </details>
  `
}

function getTablesContent () {
  return `
    <h2 id="what-is">Što je rad sa stolovima?</h2>
    <p>
      Rad sa stolovima je funkcionalnost specifična za ugostiteljske objekte (restorani, kafići, barovi).
      Omogućava spremanje narudžbi na stolove, prebacivanje artikala između stolova i spajanje narudžbi.
    </p>

    <h2 id="when-to-use" class="mt-6">Kada koristiti?</h2>
    <ul>
      <li>U restoranima i kafićima</li>
      <li>Za preuzimanje narudžbi po stolovima</li>
      <li>Za odgođeno naplat i (gost plača na kraju)</li>
    </ul>

    <h2 id="prerequisites" class="mt-6">Preduvjeti</h2>
    <ul>
      <li>Tlocrt prostora mora biti kreiran</li>
      <li>Stolovi moraju biti dodani na tlocrt</li>
      <li>Smjena mora biti otvorena</li>
    </ul>

    <h2 id="step-by-step" class="mt-6">Korak po korak</h2>

    <h3 class="mt-4">1. Otvaranje stola</h3>
    <ol>
      <li>Na blagajni kliknite ikonu "Tlocrt"</li>
      <li>Vidite grafički prikaz svih stolova</li>
      <li>Kliknite na slobodan stol (bijele boje)</li>
      <li>Stol prelazi u status "Aktivan" (žute/narančaste boje)</li>
    </ol>

    <h3 class="mt-4">2. Dodavanje artikala na stol</h3>
    <ol>
      <li>Nakon odabira stola, dodajte artikle kao i na običnom računu</li>
      <li>Kliknite "Spremi na stol" umjesto "Naplati"</li>
      <li>Narudžba se sprema na stol bez fiskalizacije</li>
      <li>Stol ostaje aktivan sa spravljenom narudžbom</li>
    </ol>

    <h3 class="mt-4">3. Ispis narudžbe na kuhinju</h3>
    <ol>
      <li>Odaberite opciju "Ispis na kuhinju"</li>
      <li>Narudžba se ispisuje na pisaču u kuhinji</li>
      <li>Narudžba ostaje na stolu</li>
    </ol>

    <h3 class="mt-4">4. Dodavanje dodatnih artikala</h3>
    <ol>
      <li>Ponovo odaberite isti stol</li>
      <li>Postojeća narudžba se učitava</li>
      <li>Dodajte nove artikle</li>
      <li>Kliknite "Spremi na stol"</li>
    </ol>

    <h3 class="mt-4">5. Zatvaranje stola (naplata)</h3>
    <ol>
      <li>Odaberite stol sa tlocrta</li>
      <li>Provjerite artikle na računu</li>
      <li>Kliknite "Naplati" ili F12</li>
      <li>Odaberite način plaćanja</li>
      <li>Račun se fiskalizira</li>
      <li>Stol postaje slobodan (bijela boja)</li>
    </ol>

    <h2 id="additional-features" class="mt-6">Dodatne funkcije</h2>

    <h3 class="mt-4">Prebacivanje artikala između stolova</h3>
    <ol>
      <li>Odaberite stol sa artiklima</li>
      <li>Kliknite "Prebaci artikal"</li>
      <li>Odaberite artikle za prebacivanje</li>
      <li>Odaberite ciljni stol</li>
      <li>Potvrdi</li>
    </ol>

    <h3 class="mt-4">Spajanje narudžbi (merge tables)</h3>
    <ol>
      <li>Odaberite prvi stol</li>
      <li>Kliknite "Spoji stolove"</li>
      <li>Odaberite drugi stol</li>
      <li>Sve narudžbe se spajaju na prvi stol</li>
      <li>Drugi stol postaje slobodan</li>
    </ol>

    <h2 id="table-statuses" class="mt-6">Statusi stolova</h2>
    <table class="info-table">
      <thead>
        <tr>
          <th>Boja</th>
          <th>Status</th>
          <th>Opis</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><span class="status-chip success">Bijela</span></td>
          <td>Slobodan</td>
          <td>Stol je prazan i dostupan</td>
        </tr>
        <tr>
          <td><span class="status-chip warning">Žuta/Narančasta</span></td>
          <td>Zauzet</td>
          <td>Na stolu je aktivna narudžba</td>
        </tr>
        <tr>
          <td><span class="status-chip error">Crvena</span></td>
          <td>Zaključan</td>
          <td>Stol koristi drugi korisnik</td>
        </tr>
      </tbody>
    </table>

    <h2 id="tips" class="mt-6">Savjeti i trikovi</h2>
    <div class="success-box">
      <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
      <div>
        <strong>Savjeti za brži rad:</strong>
        <ul>
          <li>Definirajte jasne brojeve stolova na tlocrtu</li>
          <li>Grupišite stolove po zonama (terasa, unutra, VIP)</li>
          <li>Koristite ispis na kuhinju za bolje praćenje narudžbi</li>
        </ul>
      </div>
    </div>
  `
}

function getCloseBalanceContent () {
  return `
    <h2 id="what-is">Što je zatvaranje smjene?</h2>
    <p>
      Zatvaranje smjene (Close Balance) je proces završetka rada na blagajni.
      Uključuje unos stvarnog stanja gotovine, pregled prodaje i ispis dnevnog izvještaja.
    </p>

    <h2 id="when-to-use" class="mt-6">Kada zatvoriti smjenu?</h2>
    <ul>
      <li>Na kraju radnog dana</li>
      <li>Prilikom predaje smjene drugom korisniku</li>
      <li>Za kontrolu stanja blagajne</li>
    </ul>

    <h2 id="prerequisites" class="mt-6">Preduvjeti</h2>
    <ul>
      <li>Svi računi moraju biti zatvoreni</li>
      <li>Svi stolovi moraju biti zaključani (za ugostiteljstvo)</li>
      <li>Morate prebrojiti gotovinu u blagajni</li>
    </ul>

    <h2 id="step-by-step" class="mt-6">Korak po korak</h2>

    <h3 class="mt-4">1. Priprema za zatvaranje</h3>
    <ol>
      <li>Provjerite da nisu ostali otvoreni računi</li>
      <li>Provjerite da su svi stolovi zatvoreni (ako koristite stolove)</li>
      <li>Prebrojite svu gotovinu u blagajni</li>
    </ol>

    <h3 class="mt-4">2. Pokretanje zatvaranja smjene</h3>
    <ol>
      <li>Na blagajni kliknite "Zatvori smjenu" ili "Close Balance"</li>
      <li>Sustav prikazuje pregled prodaje za smjenu</li>
    </ol>

    <h3 class="mt-4">3. Unos stvarnog stanja</h3>
    <p>Sustav prikazuje formu za unos stanja:</p>
    <table class="info-table">
      <thead>
        <tr>
          <th>Polje</th>
          <th>Opis</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>Početno stanje</strong></td>
          <td>Stanje koje ste unijeli pri otvaranju (automatski prikazano)</td>
        </tr>
        <tr>
          <td><strong>Gotovina - prodaja</strong></td>
          <td>Ukupna prodaja gotovinom (automatski izračunato)</td>
        </tr>
        <tr>
          <td><strong>Očekivano stanje</strong></td>
          <td>Početno + Prodaja (automatski izračunato)</td>
        </tr>
        <tr>
          <td><strong>Stvarno stanje</strong></td>
          <td>Iznos koji ste prebrojili - UNESITE OVDJE</td>
        </tr>
        <tr>
          <td><strong>Razlika</strong></td>
          <td>Stvarno - Očekivano (automatski izračunato)</td>
        </tr>
      </tbody>
    </table>

    <h3 class="mt-4">4. Analiza razlike</h3>
    <p>Nakon unosa stvarnog stanja:</p>
    <ul>
      <li><strong>Razlika = 0:</strong> Sve je u redu ✅</li>
      <li><strong>Razlika > 0:</strong> Višak gotovine (potrebno obrazloženje)</li>
      <li><strong>Razlika < 0:</strong> Manjak gotovine (potrebno obrazloženje)</li>
    </ul>

    <div class="warning-box mt-4">
      <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
      <strong>Važno:</strong> Ako postoji razlika, unesite obrazloženje u polje "Napomena".
    </div>

    <h3 class="mt-4">5. Pregled recapitulacije</h3>
    <p>Sustav prikazuje izvještaj sa:</p>
    <ul>
      <li>Ukupna prodaja po načinima plaćanja</li>
      <li>Broj računa</li>
      <li>Prosječan račun</li>
      <li>PDV po stopama</li>
      <li>Početno i završno stanje</li>
    </ul>

    <h3 class="mt-4">6. Završetak</h3>
    <ol>
      <li>Kliknite "Završi zatvaranje"</li>
      <li>Izvještaj se automatski ispisuje na pisaču</li>
      <li>Smjena je zatvorena</li>
      <li>Blagajna prelazi u status "OK" i spremnа je za novu smjenu</li>
    </ol>

    <h2 id="report-sections" class="mt-6">Sadržaj izvještaja</h2>
    <table class="info-table">
      <thead>
        <tr>
          <th>Sekcija</th>
          <th>Sadržaj</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>Zaglavlje</strong></td>
          <td>Datum, vrijeme, korisnik, blagajna</td>
        </tr>
        <tr>
          <td><strong>Prodaja</strong></td>
          <td>Ukupan promet, broj računa, prosječan račun</td>
        </tr>
        <tr>
          <td><strong>Načini plaćanja</strong></td>
          <td>Gotovina, kartica, POS, ostalo</td>
        </tr>
        <tr>
          <td><strong>PDV</strong></td>
          <td>Iznosi po PDV stopama (25%, 13%, 5%)</td>
        </tr>
        <tr>
          <td><strong>Gotovina</strong></td>
          <td>Početno stanje, prodaja, očekivano, stvarno, razlika</td>
        </tr>
        <tr>
          <td><strong>Stornirani računi</strong></td>
          <td>Lista storniranih računa (ako postoje)</td>
        </tr>
      </tbody>
    </table>

    <h2 id="tips" class="mt-6">Savjeti i trikovi</h2>
    <div class="success-box">
      <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
      <div>
        <strong>Najbolje prakse:</strong>
        <ul>
          <li>Zatvarajte smjenu svaki dan u isto vrijeme</li>
          <li>Uvijek prebrojite gotovinu dva puta za sigurnost</li>
          <li>Čuvajte ispisane izvještaje najmanje 5 godina (zakonska obaveza)</li>
          <li>Dokumentirajte sve razlike u gotovini</li>
        </ul>
      </div>
    </div>

    <h2 id="troubleshooting" class="mt-6">Što ako...?</h2>
    <details>
      <summary>Ne mogu zatvoriti smjenu - ima otvorenih stolova?</summary>
      <p>
        Morate zatvoriti sve stolove prije zatvaranja smjene. Idite na tlocrt
        i zatvorite sve aktivne stolove.
      </p>
    </details>

    <details>
      <summary>Razlika u gotovini je velika?</summary>
      <p>
        Provjerite:
      </p>
      <ul>
        <li>Jeste li ispravno prebrojili gotovinu?</li>
        <li>Postoje li stornirani računi?</li>
        <li>Je li bilo povrata novca?</li>
        <li>Jeste li unijeli ispravno početno stanje?</li>
      </ul>
      <p>Kontaktirajte nadređenog ili administratora za pomoć.</p>
    </details>

    <details>
      <summary>Zaboravio sam zatvoriti smjenu?</summary>
      <p>
        Možete zatvoriti smjenu i sljedeći dan. Međutim, preporuča se zatvoriti
        svaku smjenu na kraju radnog dana za pravilnu evidenciju.
      </p>
    </details>
  `
}
